import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
    apiKey: "AIzaSyAY-LRrcp7w2oANfmNmfs2l1jgd1zmrLM4",
    authDomain: "react-tutorial-marioplan-fcd5a.firebaseapp.com",
    databaseURL: "https://react-tutorial-marioplan-fcd5a.firebaseio.com",
    projectId: "react-tutorial-marioplan-fcd5a",
    storageBucket: "react-tutorial-marioplan-fcd5a.appspot.com",
    messagingSenderId: "1056136587637",
    appId: "1:1056136587637:web:dda40e471b3daeaa6ccb3c",
    measurementId: "G-EJY0KTSY7K"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  // firebase.analytics();
  // firebase.firestore().settings({ timestampsInSnapshots: true })

  export default firebase;